import React, { useState } from 'react'
import './Text.sass'
import PropTypes from 'prop-types'
import { stripHtmlTags } from '../../Helpers/Misc'

const FoldedText = ({
  children,
  initialCharacters,
  contentEditable,
  ...props
}) => {
  const [expanded, setExpanded] = useState(false)
  return (
    <>
      <p
        {...props}
        contentEditable={contentEditable}
        data-edit-name={props['data-edit-name']}
      >
        {expanded ? (
          <div dangerouslySetInnerHTML={{ __html: children }} />
        ) : (
          `${stripHtmlTags(children).slice(0, initialCharacters)}${
            children.length > initialCharacters ? '...' : ''
          }`
        )}
      </p>
      {children.length > initialCharacters && (
        <p
          className={'foldedTextSeeMore'}
          onClick={() => setExpanded(!expanded)}
        >
          see {!expanded ? 'more' : 'less'}
        </p>
      )}
    </>
  )
}

FoldedText.propTypes = {
  children: PropTypes.string.isRequired,
  className: PropTypes.string,
  initialCharacters: PropTypes.number,
}

FoldedText.defaultProps = {
  children: '',
  className: '',
  initialCharacters: 50,
}

export default FoldedText
